module.exports = __webpack_public_path__ + "6bf446439058c85d4e2d68632f4ff646.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_12.jpg
// module id = 1695
// module chunks = 5